module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-container"
  }, [(_vm.$route.name !== 'Product') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "logo-wrapper"
  }, [_c('a', {
    staticClass: "champ-logo",
    attrs: {
      "href": "https://www.championat.com/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'championat-logo')
      }
    }
  }, [_c('champlogo')], 1), _vm._v(" "), _c('a', {
    staticClass: "fifa-logo",
    attrs: {
      "target": "_blank",
      "href": "https://www.easports.com/ru/fifa/buy/russia?utm_campaign=fifa18_hd_ru_scm_fixd_dcm&utm_medium=display&utm_source=championat_logo_sp&utm_content=banner&utm_term=c3"
    },
    on: {
      "click": function($event) {
        _vm.Helpers.ga().send('click', 'fifa-logo')
      }
    }
  }, [_c('fifalogo')], 1)]) : _vm._e(), _vm._v(" "), (_vm.Helpers.isMobile() || _vm.Helpers.isTouch()) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "burger",
    class: {
      open: _vm.isToggle
    },
    on: {
      "click": _vm.openMobileMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animate),
      expression: "animate"
    }],
    staticClass: "nav",
    class: {
      open: _vm.isToggle
    }
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('О проекте')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link index",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("О проекте")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Правила')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/rules"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("Правила")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Тест')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/test"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("Тест")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Видеоотчеты')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/video"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("Видеоотчеты")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('FIFA 18')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/product"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("FIFA 18")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Рейтинг')
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/rating"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v("рейтинг")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item nav-user-item",
    on: {
      "click": function($event) {
        _vm.sendEvent('Авторизация')
      }
    }
  }, [(_vm.isGuest) ? _c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.authPopup($event)
      }
    }
  }, [_vm._v("Войти")]) : _c('div', {
    staticClass: "user-link"
  }, [_c('router-link', {
    staticClass: "nav-link user",
    attrs: {
      "to": "/profile",
      "href": "#"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMobileMenu($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user.first_name))]), _vm._v(" "), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("X")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e765c05c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Header.vue
// module id = 517
// module chunks = 1